export { PessoaFisica, PessoaFisicaAutocomplete, PessoaFisicaVisualizar } from './fisica';
export { PessoaJuridica, PessoaJuridicaAutocomplete, PessoaJuridicaVisualizar } from './juridica';
